import React from 'react';
import PropTypes from 'prop-types';

import {
  Heading,
  Body,
  ExtendedFlex,
  Numeral,
} from '../../coreui';

import CalloutFrame from '../../components/CalloutFrame';
import backgroundImage from '../../assets/StressUncertaintyPanel.png';
import BrowseLink from '../../components/BrowseLink';

const ImageFrame = ({
  total1031InvestmentAmount,
  isLoggedIn,
}) => {
  return (
    <CalloutFrame
      image={backgroundImage}
      imagePosition="second"
      bg="gray.0"
    >
      <Heading
        type="H2"
        display="block"
      >
        Removing The Stress and Uncertainty
      </Heading>
      <Body
        type="B1"
        display="block"
      >
        We offer professionally managed, investment grade real estate
        opportunities that include full due diligence packets, with no 30-day escrow period.
      </Body>
      <Body
        type="B1"
        display="block"
      >
        Since inception, our experienced team of real estate, legal, and securities
        professionals has helped invest over {
          <Numeral value={total1031InvestmentAmount} format="$0a" />
        } into 1031 Exchanges.
        We are here to make the process simple.
      </Body>
      <ExtendedFlex
        mr="auto"
      >
        <BrowseLink
          anonText="Get Started"
          isLoggedIn={isLoggedIn}
        />
      </ExtendedFlex>
    </CalloutFrame>
  );
};

ImageFrame.propTypes = {
  total1031InvestmentAmount: PropTypes.number,
  isLoggedIn: PropTypes.bool,
};

export default ImageFrame;
